import * as React from "react";

export const Check = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3985 4.55159C12.6462 4.77174 12.6685 5.15098 12.4484 5.39865L7.11502 11.3986C7.00116 11.5267 6.83796 11.6 6.66658 11.6C6.49519 11.6 6.33199 11.5267 6.21813 11.3986L3.55146 8.39865C3.33131 8.15098 3.35362 7.77174 3.60129 7.55159C3.84896 7.33143 4.2282 7.35374 4.44835 7.60141L6.66658 10.0969L11.5515 4.60141C11.7716 4.35374 12.1509 4.33143 12.3985 4.55159Z"
    />
);
